import { DataStoreService } from './data-store.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { UniversalService, CountryDto, CityDto, CryptoV2Service } from '@wearenovae/novae-core-services';
import { RemoteConfigService } from './remote-config/remote-config.service';


@Injectable({
  providedIn: 'root'
})
export class RegistryLocationService {
  universalUrlBase = environment.brands[this.dataStore.brand].novaeUniversalUrlBase;
  user = 'UNIVERSAL_APP_ID';
  pass = 'b^BJCYCA;wA2w[Y#';
  idApplication = 20;
  inputCountry: CountryDto = { name: '', iso: '' };

  // Listas
  countries: CountryDto[] = [];
  cities: CityDto[] = [];

  universalJwtUrl: string;
  uJU: string;
  uJP: string;
  useJwtToken: boolean;


  constructor(
    private universalService: UniversalService,
    private dataStore: DataStoreService,
    private dataService: DataService
    , private cryptoV2Service:CryptoV2Service
    , private remoteConfigService: RemoteConfigService
  ) {
    this.universalJwtUrl = environment.brands[this.dataStore.brand].UNIVERSAL_GET_JWTTOKEN_URL || '';
    /*
    this.uJU = this.cryptoV2Service.convertResponse({content:environment.brands[this.dataStore.brand].uJU || ''}, environment.brands[this.dataStore.brand].aca); //environment.brands[this.dataStore.brand].uJU || '';
    this.uJP = this.cryptoV2Service.convertResponse({content:environment.brands[this.dataStore.brand].uJP || ''}, environment.brands[this.dataStore.brand].aca); //environment.brands[this.dataStore.brand].uJP || '';
    //*/
    
    const remoteValues = this.remoteConfigService.getValues();
    if (remoteValues) {
      this.uJU = remoteValues.uJU;
      this.uJP = remoteValues.uJP;
    }

    this.useJwtToken = this.dataService.getJwtUse();
  }

  async getCountries() {
    try {
      const res = await this.universalService.getCountries(this.universalUrlBase).toPromise();
      this.countries = res.countryDtoList;
      this.dataStore.countryList = res.countryDtoList;
    } catch (error) {
      
    }
  }
  // ANTES DE EJECUTAR ESTE METODO SE DEBE SELECCIOAR UN PAIS Y ENVIARLO AL METODO "getCityByCountryId"
  async getCities(Country) {
    if (Country) {
      this.cities = await this.universalService.getCityByCountryId(Country, this.universalUrlBase, atob(this.universalJwtUrl),
        atob(this.uJU),
        atob(this.uJP),
        this.useJwtToken
      ).toPromise()
      .then((res) => {
        return res.cityDtoList;
      })
      .catch((error) => {
        return [];
      });
    }
  }

}
